import {BehaviorSubject} from "rxjs";
import {map} from "rxjs/operators";

export class SocketUtils {
  public static socketAction: BehaviorSubject<{actionName: string, payload: any}> = new BehaviorSubject<{actionName: string, payload: any}>(undefined);

  public static listenToSocketEventByActionName(actionName: string ){
    // return new Promise((resolve, reject) => {
      return SocketUtils.socketAction.pipe(map(res=>{
        if(res && res?.actionName === actionName){
          return res?.payload;
        }
      }))
    // });
  }

  public static sendNewEventByActionName(actionName: string, payload: any){
    SocketUtils.socketAction.next({actionName, payload})
  }
}
